import { render, staticRenderFns } from "./ExpandedTopVideos.vue?vue&type=template&id=6db459ba&scoped=true&"
import script from "./ExpandedTopVideos.vue?vue&type=script&lang=js&"
export * from "./ExpandedTopVideos.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedTopVideos.vue?vue&type=style&index=0&id=6db459ba&prod&lang=scss&"
import style1 from "./ExpandedTopVideos.vue?vue&type=style&index=1&id=6db459ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db459ba",
  null
  
)

export default component.exports